module.exports = __webpack_public_path__ + "static/media/bell.47a38ca8.svg";